import React, { ReactElement } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { EntityRowSpacing } from 'services/entities/types';
import { AppState } from 'services/types';
import { makeSelectRowSpacingsWithInvalidRate } from 'services/equipmentSets/selectors';
import { EquipmentSetsProps } from 'services/equipmentSets/types';
import WarningMessage from 'components/WarningMessage';

type OwnProps = EquipmentSetsProps;

interface ConnectedProps {
    rowSpacingsWithInvalidRate: EntityRowSpacing[];
}

export type Props = ConnectedProps & OwnProps;

export class RowSpacingsWithInvalidRateAlertComponent extends React.PureComponent<
    Props
> {
    render(): ReactElement | null {
        const { rowSpacingsWithInvalidRate, applicationRate } = this.props;

        if (
            !rowSpacingsWithInvalidRate ||
            !rowSpacingsWithInvalidRate.length ||
            !applicationRate
        ) {
            return null;
        }

        const content = rowSpacingsWithInvalidRate
            .map(rowSpacing => `${rowSpacing}m`)
            .join(', ');

        return (
            <Grid.Row>
                <Grid.Column>
                    <div className="calibration-status-section">
                        <WarningMessage
                            title={`Your equipment is NOT setup at ${applicationRate} L/Ha for row widths:`}
                            content={content}
                            visible
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rowSpacingsWithInvalidRate: makeSelectRowSpacingsWithInvalidRate()
});

export default connect(mapStateToProps)(
    RowSpacingsWithInvalidRateAlertComponent
);
